var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33317 0.75C5.1665 0.75 1.60817 3.34167 0.166504 7C1.60817 10.6583 5.1665 13.25 9.33317 13.25C13.4998 13.25 17.0582 10.6583 18.4998 7C17.0582 3.34167 13.4998 0.75 9.33317 0.75ZM9.33317 11.1667C7.03317 11.1667 5.1665 9.3 5.1665 7C5.1665 4.7 7.03317 2.83333 9.33317 2.83333C11.6332 2.83333 13.4998 4.7 13.4998 7C13.4998 9.3 11.6332 11.1667 9.33317 11.1667ZM9.33317 4.5C7.94984 4.5 6.83317 5.61667 6.83317 7C6.83317 8.38333 7.94984 9.5 9.33317 9.5C10.7165 9.5 11.8332 8.38333 11.8332 7C11.8332 5.61667 10.7165 4.5 9.33317 4.5Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/openEye.c4d9605aeb43b0366c9793694e421d5c.svg";
export { ForwardRef as ReactComponent };